import { useEffect, useState } from "react";
import VideoCard from "../../components/admin/video/VideoCard";
import VideoLayoutCard from "../../components/admin/video/VideoLayoutCard";
import Pagination from "../../components/Pagination";
import { getYoutubePageCount, getYoutubeVideo } from "../../services/VideoAPI";
import "../Main.css";
export const AdminVideoList = (props) => {
  const [cardList, setCardList] = useState([]);
  const [updateState, setUpdateState] = useState();

  const getVideoList = () => {
    if (props.selectedPage !== undefined) {
      if (props.selectedPage < 0) {
        window.location.href = `/admin/video?page=1`;
      }
      getYoutubeVideo(props.selectedPage).then((res) => {
        if (res.data.length === 0 && props.selectedPage > 0) {
          getYoutubePageCount().then((res) => {
            window.location.href = `/admin/video?page=${res.data}`;
          });
        }

        let cards = [];
        res.data.map((video) => {
          cards.push(
            <VideoCard
              key={video["id"]}
              id={video["id"]}
              title={video["title"]}
              url={video["youtubeURL"]}
              getVideoList={getVideoList}
              setSelectedPage={props.setSelectedPage}
              changePage={props.changePage}
              pageCount={props.pageCount}
              setYoutubeCount={props.setYoutubeCount}
              setUpdateState={setUpdateState}
            />
          );
        });
        setCardList(cards);
      });
    }
  };

  useEffect(() => {
    getVideoList();
  }, [props.selectedPage, updateState]);

  return (
    <>
      <VideoLayoutCard cardList={cardList} />
      <Pagination
        selectedPage={props.selectedPage}
        changePage={props.changePage}
        pageCount={props.pageCount}
      />
    </>
  );
};
